import { __decorate } from "tslib";
import { AutoEncoder, BooleanDecoder, field, StringDecoder } from '@common/encoding';
/**
 * Missing preferences are enabled.
 * `type` and `channel` are decoded as plain strings so older clients keep working when new values are added.
 */
export class NotificationPreference extends AutoEncoder {
    type;
    channel;
    enabled = true;
}
__decorate([
    field({ decoder: StringDecoder })
], NotificationPreference.prototype, "type", void 0);
__decorate([
    field({ decoder: StringDecoder })
], NotificationPreference.prototype, "channel", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], NotificationPreference.prototype, "enabled", void 0);
//# sourceMappingURL=NotificationPreference.js.map